import { createSlotRecipe } from './runtime.js';

const datePickerConfig = {"name":"datePicker","slots":["content","rangeRoot","body","viewControl","rangeText","prevTrigger","nextTrigger","table","tableHead","tableRow","tableHeader","tableBody","tableCell","tableCellTrigger","dayPill","monthGroup","presetList","presetDivider","footer"],"variantMap":{"range":["true"]}}

export const datePicker = /* @__PURE__ */ createSlotRecipe(datePickerConfig)